import axios from "axios";
import NProgress from "nprogress";

let api = {
  url: "",
  token: "",
  init(url: string, token: string) {
    this.url = url;
    this.token = token;
    return this;
  },
  call: (method: string, path: string, params: Record<string, any>) => {
    if (method !== "get") {
      NProgress.start();
      NProgress.set(0.1);
    }
    return new Promise((accept: Function, reject: Function) => {
      let headers: Record<string, string> = {};
      let config: Record<string, any> = {
        method: method,
        url: `${api.url}${path}`,
        headers: headers
      };
      if (api.token) {
        headers["x-access-token"] = api.token;
      }
      headers["api-source"] = "frontend";
      if (["get", "delete"].indexOf(method) >= 0) {
        config.params = params;
      } else {
        config.data = params;
      }
      axios(config)
        .then(resp => {
          NProgress.done();
          accept(resp.data);
        })
        .catch(error => {
          NProgress.done();
          reject(error.response.data);
        });
    });
  },
  file: (method: string, path: string, file: any) => {
    return new Promise((accept: Function, reject: Function) => {
      let headers: Record<string, string> = {
        "Content-Type": "multipart/form-data"
      };
      if (api.token) {
        headers["x-access-token"] = api.token;
      }

      let config: Record<string, any> = {
        method: method,
        url: `${api.url}${path}`,
        headers: headers,
        data: file
      };
      axios(config)
        .then(resp => accept(resp.data))
        .catch(error => reject(error.response.data));
    });
  }
};

export default api;
